<template>
  <v-chart
    :options="options"
    :autoresize="true"
    style="width:100%; height:100%; cursor: default;"
  />
</template>

<style>
/**
 * The default size is 600px×400px, for responsive charts
 * you may need to set percentage values as follows (also
 * don't forget to provide a size for the container).
 */
.echarts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import ECharts from 'vue-echarts';

import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/polar';

export default {
  components: {
    'v-chart': ECharts,
  },
  props: ['data', 'name', 'valueFormatter'],
  data() {
    return {};
  },
  computed: {
    options() {
      return {
        legend: {
          show: false,
        },
        tooltip: {
          trigger: 'item',
          formatter: params => {
            const value = this.valueFormatter
              ? this.valueFormatter(params.value)
              : params.value;
            return `${params.seriesName} <br /> ${params.name}: ${value}`;
          },
        },
        xAxis: {
          data: this.data.map(d => d.x),
          show: false,
        },
        yAxis: {
          show: false,
        },
        grid: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        },
        series: [
          {
            color: ['#bfd8f5'],
            name: this.name,
            type: 'bar',
            data: this.data.map(d => d.y),
            animationDelay: function(idx) {
              return idx * 10;
            },
          },
        ],
      };
    },
  },
};
</script>
